module.exports = __webpack_public_path__ + "img/et_yes.46add52e.png";